import ActionTypes from '../actions/actionTypes';

const initialState = {
  store: {
    getCardOptions: {
      isLoading: false,
      cardOptions: [],
      isError: false,
    },
    getVehicleTypes: {
      isLoading: false,
      vehicleTypes: [],
      isError: false,
    },
    createCardOptions: {
      isLoading: false,
      createCardOptionsResponse: {},
      isError: false,
      isSuccess: false,
    },
    updateCardOptions: {
      isLoading: false,
      updateCardOptionsResponse: {},
      isError: false,
      isSuccess: false,
    },
  },
  reportTypesLoading: false,
  reportTypesLoaded: false,
  reportTypesError: false,
  reportTypes: []
};

export function getCardOptionsReducer(state = initialState.store.getCardOptions, { type, payload }) {
  let cardOptions;
  switch (type) {
    case ActionTypes.STORE.GET_CARD_OPTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case ActionTypes.STORE.GET_CARD_OPTIONS.SUCCESS:
      cardOptions = payload.cardOptions;
      return {
        ...state,
        isLoading: false,
        cardOptions,
      };
    case ActionTypes.STORE.GET_CARD_OPTIONS.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case ActionTypes.STORE.GET_CARD_OPTIONS.RESET:
      return {
        ...state,
        isLoading: false,
        isError: false,
        cardOptions: [],
      };
    default:
      return state;
  }
}

export function getVehicleTypeReducer(state = initialState.store.getVehicleTypes, { type, payload }) {
  let vehicleTypes;
  switch (type) {
    case ActionTypes.STORE.GET_VEHICLE_TYPES.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case ActionTypes.STORE.GET_VEHICLE_TYPES.SUCCESS:
      vehicleTypes = payload.vehicleTypeResponse;
      return {
        ...state,
        isLoading: false,
        vehicleTypes,
      };
    case ActionTypes.STORE.GET_VEHICLE_TYPES.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    default:
      return state;
  }
}

export function createCardOptionsReducer(state = initialState.store.createCardOptions, { type, payload }) {
  let createCardOptionsResponse;
  switch (type) {
    case ActionTypes.STORE.CREATE_CARD_OPTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        isSuccess: false,
      };
    case ActionTypes.STORE.CREATE_CARD_OPTIONS.SUCCESS:
      createCardOptionsResponse = payload;
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        createCardOptionsResponse
      };
    case ActionTypes.STORE.CREATE_CARD_OPTIONS.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    default:
      return state;
  }
}

export function updateCardOptionsReducer(state = initialState.store.updateCardOptions, { type, payload }) {
  let updateCardOptionsResponse;
  switch (type) {
    case ActionTypes.STORE.UPDATE_CARD_OPTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        isSuccess: false,
      };
    case ActionTypes.STORE.UPDATE_CARD_OPTIONS.SUCCESS:
      updateCardOptionsResponse = payload;
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        updateCardOptionsResponse
      };
    case ActionTypes.STORE.UPDATE_CARD_OPTIONS.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    default:
      return state;
  }
}

export function storeReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.STORE.GET_REPORT_TYPES.REQUEST:
      return {
        ...state,
        reportTypesLoading: true,
        reportTypesLoaded: false,
        reportTypesError: false
      };
    case ActionTypes.STORE.GET_REPORT_TYPES.SUCCESS:
      return {
        ...state,
        reportTypesLoading: false,
        reportTypseLoaded: true,
        reportTypes: payload.reportTypes
      };
    case ActionTypes.STORE.GET_REPORT_TYPES.FAILURE:
      return {
        ...state,
        reportTypesLoading: false,
        reportTypesError: true
      };
    default:
      return state;
  }
}
